import { Observable } from 'rxjs'

import { Injectable } from '../injector'
import { UserApiService } from './UserApiService'
import { getPlatform } from '../PlatformUtils'

@Injectable()
export class CashierService extends UserApiService {
	preparePayment(bundle: Bundle, provider: PaymentProvider, token?: string, sessionId: string = '', source?: string): Promise<PreparePaymentResponse> {
		let url = ''
		if (token) {
			url += '/payment/prepare/token/' +
                bundle.id + '/' + provider + '/' + token + '?tmxsid=' + sessionId
		}
		else {
			url += '/payment/prepare/' +
                bundle.id + '/' + provider + '?tmxsid=' + sessionId
		}

		url += '&platform=' + getPlatform()

		if (source) {
			url += '&source=' + encodeURIComponent(source)
		}

		return this.httpGet(url).toPromise()
	}

	fetchCashOuts(): Promise<GroupedCashoutDto[]> {
		return this.httpGet<GroupedCashoutDto[]>('/user/cashout/list').toPromise()
	}

	cancelCashout(ids: number[]): Promise<{}> {
		return this.httpPost('/user/cashout/cancel', ids).toPromise()
	}

	getCashoutInfo(): Promise<UserCashoutInfo> {
		return this.httpGet<UserCashoutInfo>('/user/cashout/info').toPromise()
	}

	getUserPurchaseLimits(): Promise<PurchaseLimitInfo> {
		return this.httpGet<PurchaseLimitInfo>('/payment/limits').toPromise()
	}

	getPurchaseInfo(invoiceId: string): Observable<PurchaseInfo> {
		return this.httpGet<PurchaseInfo>('/payment/' + invoiceId)
	}

	hasUserMadePurchases(): Promise<boolean> {
		return this.httpGet<boolean>('/payment/has-made-purchases').toPromise()
	}
}
